import React from "react";
import { Box, Typography } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import {
  BgBox,
  InlineFlexBoxs,
  InsideListItems,
  SmallBgBox,
  ListItems,
  Titles,
} from "my-tax/styles/my-tax-credit-information.style";
import { OcFooter } from "oc/components";
import { ocLightTheme } from "oc/themes/oc-light-theme";

export const MyTaxThreeChildrenOrMoreTaxCreditInformationPage = () => {
  return (
    //Ha eltávolítjuk a ThemeProvider-ert, akkor nem jeleníti meg a stílusokat. Feltételezhetően azért, mert új tab-on nyílik meg.
    //If we remove the ThemeProvider, it will not display the styles. Probably because it opens in a new tab.
    <ThemeProvider theme={ocLightTheme}>
      <Box>
        <Box padding="16px" style={{ backgroundColor: "#F1F3F4" }}>
          <Box>
            <Typography
              variant="h4"
              style={{
                fontSize: "34px",
                fontWeight: "400",
                color: "#5E6366",
                display: "flex",
                justifyContent: "center",
              }}
            >
              Tájékoztató
            </Typography>
            <Box height="32px" />
            <Typography
              variant="h5"
              style={{
                fontSize: "24px",
                fontWeight: "400",
                color: "#212121",
                display: "flex",
                justifyContent: "center",
              }}
            >
              a két, a három, illetve a négy vagy több gyermeket nevelő anyák kedvezményének érvényesítéséről
              szóló adóelőleg-nyilatkozathoz
            </Typography>
            <Box height="32px" />
            <InlineFlexBoxs>
              <BgBox>
                <Typography variant="h5" component={Titles}>
                  <b>Tudnivalók a nyilatkozathoz</b>
                </Typography>
                <Box height="32px" />
                <Typography variant="body1">
                  <b>Ha Ön a</b> két, a három, illetve a négy vagy több gyermeket nevelő anyák kedvezményére (a továbbiakban: <b>több
                    gyermeket nevelő anyák kedvezményére) jogosító gyermekek után családi kedvezményre is jogosult, akkor
                    a családi kedvezményről szóló összevont adóelőleg-nyilatkozaton a több gyermeket nevelő anyák
                    kedvezményéről is tud nyilatkozni</b> a munkáltató, illetve az összevont adóalapba tartozó rendszeres bevételt
                  (különösen havi, heti bért, munkadíjat, tiszteletdíjat, személyes közreműködés ellenértékét, egyéb juttatást)
                  juttató kifizetőnek. Ekkor ezt az adóelőleg nyilatkozatot nem kell benyújtania. Ha a több gyermeket nevelő anyák
                  kedvezményének valamelyikére jogosult anya <b>nem rendszeres bevételt juttató kifizetőtől</b> is szerez jövedelmet,
                  akkor a kedvezmény érvényesítéséhez ezt a nyilatkozatot kell a kifizetőnek eljuttatnia, összevont adóelőleg-
                  nyilatkozat a nem rendszeres bevételt juttató kifizetőnek nem adható.
                </Typography>
                <Box height="32px" />
                <Typography variant="body1">
                  <b>2026. január 1-től adóalap-kedvezményt vehetnek igénybe azok a két gyermeket nevelő anyák is, akik 2025
                    december 31-e után töltik be a 40. életévüket</b> (1986-ban vagy azt követően születtek).
                </Typography>
                <Box height="32px" />
                <Typography variant="body1">
                  A több gyermeket nevelő anyák kedvezménye alatt együttesen értjük a két gyermeket nevelő anyák
                  kedvezményét, a három gyermeket nevelő anyák kedvezményét és a négy vagy több gyermeket nevelő anyák
                  kedvezményét.
                </Typography>
                <Box height="32px" />
                <Typography variant="h6">
                  <b>Kinek kell átadni ezt a nyilatkozatot?</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  Ahhoz, hogy a munkáltatója, kifizetője az Ön törvényben meghatározott jövedelmeire a több gyermeket nevelő
                  anyák kedvezményének valamelyikét figyelembe véve állapítsa meg az adóelőleget, ezt a nyilatkozatot két
                  példányban kell átadnia részére.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  A nyilatkozat egyik példányát a munkáltatónak (kifizetőnek), másik példányát pedig Önnek kell a bevallás
                  benyújtásának évét követő 5. év végéig megőriznie.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  Az adóelőleg-nyilatkozat nem kizárólag munkáltatónak adható át, hanem olyan kifizetőnek is, aki Önnek a
                  törvényben nevesített (1.) összevonás alá eső jövedelmet juttat.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  A munkáltató, kifizető a nyilatkozatot az átadást követő kifizetéseknél veszi figyelembe az adóéven belül, vagy
                  kérésére folyamatosan.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  2026-tól minden a kedvezményre jogosult több gyermeket nevelő anyának lehetősége van arra, hogy kérje a
                  munkáltatót, kifizetőt, hogy a kedvezményt az adóelőleg-nyilatkozat visszavonásáig vegye folyamatosan
                  figyelembe (folytatólagos nyilatkozat), amit a 3. pontban kell jelezni. Ekkor a következő évben, években nem
                  kell új nyilatkozatot adnia.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  <i>
                    Ha Ön a több gyermeket nevelő anyák kedvezményét jogalap nélkül kéri, és emiatt az adóbevallásában 10 ezer
                    forintot meghaladó befizetési kötelezettsége, vagyis adóhátraléka keletkezik, akkor ennek 12 százalékát
                    különbözeti bírságként kell megfizetnie az adóhátralékkal együtt.
                  </i>
                </Typography>
                <Box height="25px" />
                <Typography variant="h6">
                  <b>Kinek jár a kedvezmény?</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  <b>
                    Több gyermeket nevelő anya az a nő, aki vér szerinti vagy örökbefogadó szülőként
                  </b>{" "}
                  az általa nevelt két,
                  három, illetve négy vagy több gyermek után:
                </Typography>
                <Box height="10px" />
                <Box marginLeft="20px">
                  <Typography variant="body1">
                    a) családi pótlékra jogosult, vagy
                  </Typography>
                  <Box height="10px" />
                  <Typography variant="body1">
                    b) családi pótlékra már nem jogosult, de legalább 12 éven
                    keresztül jogosult volt,
                  </Typography>
                  <Box height="10px" />
                  <Typography variant="body1">
                    c) a családi pótlékra való jogosultsága a gyermek elhunyta miatt szűnt meg.{" "}
                  </Typography>
                </Box>
                <Typography variant="body1">
                  Az a) pont szerinti gyermeknek kell tekinteni azt a gyermeket
                  is, aki fogyatékkal élőként szociális intézményben látnak el,
                  utána az anya családi pótlékra nem jogosult, de a gyermeket az
                  anyát megillető családi pótlék összegének meghatározásakor
                  figyelembe veszik.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  A b) pont szerinti gyermeknek kell tekinteni azt a gyermeket is,
                  aki után az anya vagy a szociális intézmény vezetője családi
                  pótlékra való jogosultsága már nem áll fenn, de legalább 12 éven
                  keresztül e két személy valamelyike, vagy mindkettőjük esetében
                  összesen fennállt, feltéve, hogy a szociális intézmény
                  vezetőjénél fennálló jogosultság időszaka alatt az előző
                  mondatban foglaltak teljesültek.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  Például <b>négy vagy több gyermeket nevelő anyának számít</b> az
                  a nő, aki:
                </Typography>
                <Typography variant="body1" component={ListItems}>
                  <li>
                    saját háztartásában neveli a 3, 6, 9 és 12 éves gyermekeit;
                  </li>
                  <li>
                    öt gyermeket szült, a szülők elváltak, amikor a két legidősebb
                    gyermek 16 és 14 éves volt, a három fiatalabb gyermek az
                    anyánál maradt, a két idősebb az apához került;
                  </li>
                  <li>
                    három gyermeket szült és nevelt: a legidősebb dolgozik,
                    elköltözött otthonról, a középső egyetemista, a harmadik
                    középiskolába jár, és korábban örökbefogadott egy 3 éves
                    kislányt, aki 22 évesen költözött el a szülői házból.{" "}
                  </li>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  <b>Nem tekinthető négy vagy több gyermeket nevelő anyának</b> az a nő, aki például:
                </Typography>
                <Typography variant="body1" component={ListItems}>
                  <li>
                    négy gyermeket szült, de váláskor az apához került 10 éves kislánya;
                  </li>
                  <li>
                    második férjével közösen nevel négy kiskorú gyermeket, akik közül kettő a sajátja, kettő a férjéé (kivéve,
                    ha a férje gyermekeit örökbe fogadta).
                  </li>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  <b>Három gyermeket nevelő anya az a nő,</b> aki például:
                </Typography>
                <Typography variant="body1" component={ListItems}>
                  <li>
                    egy egyetemista és két középiskolás gyermekét neveli;
                  </li>
                  <li>
                    három gyermeket szült, ebből kettőt felnevelt (már felnőttek), egyikük pedig kisgyermekként elhunyt;
                  </li>
                  <li>
                    két gyermeket szült, akiket együtt nevel a férje gyermekével, akit korábban örökbe fogadott.
                  </li>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  <b>Nem tekinthető három gyermeket nevelő anyának</b> az
                  a nő, aki például:
                </Typography>
                <Typography variant="body1" component={ListItems}>
                  <li>
                    három gyermeket szült és nevel, de a legnagyobb, már felnőtt gyermeke külföldön született, és emiatt
                    utána csak 10 évig volt jogosult Magyarországon családi pótlékra;
                  </li>
                  <li>
                    a két saját gyermeke mellett nevelőszülőként egy kislányt gondoz.
                  </li>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  <b>2026-ban a két gyermeket nevelő anyák kedvezményét az az anya érvényesítheti, aki 2025 december 31-e
                    után tölti be a 40. életévét.</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  <b>A két gyermeket nevelő anyák kedvezményét</b> érvényesítheti az a nő, aki
                </Typography>
                <Typography variant="body1" component={ListItems}>
                  <li>
                    36 éves és az óvodás és a kisiskolás gyermekét neveli,
                  </li>
                  <li>
                    2026. január 1-jén tölti be a 40. életévét és ikergyermekei már felnőttek,
                  </li>
                  <li>
                    32 éves és két örökbefogadott gyermeket nevel.
                  </li>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  Nem érvényesítheti a két gyermeket nevelő anyák kedvezményét az az anya, aki
                </Typography>
                <Typography variant="body1" component={ListItems}>
                  <li>
                    férjével közösen neveli közös gyermeküket és a férfi előző kapcsolatából származó gyermekét (kivéve,
                    ha férje gyermekét örökbe fogadta),
                  </li>
                  <li>
                    saját gyermeke mellett nevelőszülőként egy kislányt nevel,
                  </li>
                  <li>
                    57 éves és két felnőtt gyermeke van.
                  </li>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  Ha a továbbiakban nem kívánja igénybe venni a több gyermeket nevelő anyák kedvezményét, (például, mert a
                  kedvezményre már nem jogosult) akkor ezt a 4. sorban kell jelölnie.
                </Typography>
                <Box height="25px" />
                <Typography variant="h6">
                  <b>Milyen jövedelmekre érvényesíthető a kedvezmény?</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  A több gyermeket nevelő anyák kedvezménye{" "}
                  <b>
                    törvényi előírások szerint az alábbi jövedelmekre
                    érvényesíthető:
                  </b>
                </Typography>
                <Typography variant="body1" component={ListItems}>
                  <li>
                    a bérnek minősülő és más nem önálló tevékenységből származó
                    jövedelemre, ilyenek különösen:
                  </li>
                </Typography>
                <Typography variant="body1" component={InsideListItems}>
                  <li>
                    a munkaviszonyból, közfoglalkoztatási jogviszonyból származó
                    jövedelem,
                  </li>
                  <li>
                    az adóköteles társadalombiztosítási ellátás (például: táppénz,
                    csecsemőgondozási díj, gyermekgondozási díj),
                  </li>
                  <li>
                    a szociális igazgatásról és szociális ellátásokról szóló
                    törvény alapján folyósított adóköteles ellátások,
                  </li>
                  <li>
                    a foglalkoztatás elősegítéséről és a munkanélküliek
                    ellátásáról szóló törvény alapján folyósított álláskeresési
                    járadék, nyugdíj előtti álláskeresési segély, álláskeresési
                    segély, kereset-kiegészítés és keresetpótló juttatás,
                    álláskeresést ösztönző juttatás;
                  </li>
                  <li>
                    a Magyar Honvédségnél tartalékos katonai szolgálatot teljesítő
                    magánszemély e jogviszonyból származó jövedelme,
                  </li>
                  <li>
                    ez előzőekben meghatározott jövedelmet pótló kártérítés
                    (keresetpótló járadék),
                  </li>
                  <li>
                    a nevelőszülői foglalkoztatási jogviszonyban végzett
                    tevékenység díjazása,
                  </li>
                  <li>
                    a munkaviszony megszűnése miatt kifizetett végkielégítés, de a
                    végkielégítés törvényben meghatározott mértéket meghaladó
                    része nem képezi a kedvezmény alapját,
                  </li>
                  <li>
                    a társas vállalkozás magánszemély tagjának személyes
                    közreműködése ellenértékeként kifizetett jövedelem,
                  </li>
                  <li>
                    a gazdasági társaság vezető tisztségviselőjének tevékenységére
                    tekintettel adott juttatás,
                  </li>
                  <li>
                    a jogszabály alapján választott vagy kijelölt tisztségviselő
                    tevékenysége (például igazgatótanácsi tag, felügyelőbizottsági
                    tag) ellenértékeként kapott juttatás,
                  </li>
                  <li>
                    nemzetközi szerződés hatálya alatt a nem önálló munkából,
                    ennek hiányában az adott állam joga szerinti munkaviszonyból
                    származó jövedelem,
                  </li>
                  <li>
                    az országgyűlési képviselők, nemzetiségi szószólók,
                    polgármesterek e tevékenységből származó jövedelme,
                  </li>
                  <li>
                    az állami projektértékelői jogviszonyból származó jövedelem.
                  </li>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1" component={ListItems}>
                  <li>Az önálló tevékenységből származó jövedelmek közül:</li>
                </Typography>
                <Typography variant="body1" component={InsideListItems}>
                  <li>
                    a vállalkozói jövedelem szerinti adózást alkalmazó egyéni
                    vállalkozó vállalkozói kivétjére, átalányadózás esetén az
                    átalányban megállapított jövedelmére,
                  </li>
                  <li>
                    a mezőgazdasági őstermelő e tevékenységéből származó
                    jövedelmére,
                  </li>
                  <li>
                    az európai parlamenti képviselő e tevékenységéből származó
                    jövedelmére,
                  </li>
                  <li>
                    a helyi önkormányzati képviselő e tevékenységéből származó
                    jövedelmére,
                  </li>
                  <li>
                    a választott könyvvizsgáló e tevékenységéből származó
                    jövedelmére,
                  </li>
                  <li>
                    a magánszemély által nem egyéni vállalkozóként kötött, díjazás
                    ellenében történő munkavégzésre irányuló, más szerződés
                    alapján folytatott tevékenységéből, például megbízásból
                    származó jövedelmére.
                  </li>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  A kedvezményre való{" "}
                  <b>
                    jogosultság annak a hónapnak az első napján kezdődik, amelyben
                    Ön először – akár csak egy napig is – több gyermeket nevelő anyának minősül.
                  </b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  A kedvezményre való{" "}
                  <b>
                    jogosultság annak a hónapnak az utolsó napján szűnik meg,
                    amelyben Ön utoljára, legalább egy napig több
                    gyermeket nevelő anyának minősül.
                  </b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  Például egy házaspár három gyermeket nevel, akik 6, 9 és 12 évesek. A szülők novemberben elválnak, és a két
                  idősebb gyermek az édesapával marad. Ebben az esetben az anya utoljára novemberben tekinthető három
                  gyermeket nevelő anyának, így az adóelőleg-nyilatkozat kitöltésekor december hónapot kell megjelölnie a
                  jogosultság megszűnésének hónapjaként.
                </Typography>
                <Box height="25px" />
                <Typography variant="h6">
                  <b>Hogyan érvényesíthető együtt több szja-kedvezmény?</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  A több gyermeket nevelő anyák kedvezményét <b>a 30 év alatti anyák kedvezményét követő, de minden más
                    kedvezményt megelőző sorrendben</b> érvényesíti a munkáltató, kifizető. Ez azt jelenti, hogy Ön az említett
                  jövedelmeire nem tudja a többi kedvezményt (például az első házasok kedvezményét, a családi kedvezményt)
                  érvényesíteni, annak azonban nincs akadálya, hogy a <b>családi járulékkedvezményt</b> érvényesítse. Annak
                  érdekében, hogy Ön a családi járulékkedvezményt is igénybe tudja venni, a családi kedvezmény igénybevételére
                  vonatkozó adóelőleg-nyilatkozatot is ki kell töltenie és el kell juttatnia a munkáltatójának, rendszeres bevételt
                  juttató kifizetőjének.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  Hasonlóan kell eljárnia akkor is, ha van olyan összevont adóalapba tartozó jövedelme, amelyre a több gyermeket
                  nevelő anyák kedvezményét nem tudja érvényesíteni, de a személyi kedvezményt, az első házasok kedvezményét,
                  a családi kedvezményt vagy családi járulékkedvezményt igen.
                </Typography>
                <Box height="25px" />
                <Typography variant="h6">
                  <b>Adatváltozáskor mit kell tenni?</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  Ha a nyilatkozatban közölt adatok változnak,{" "}
                  <b>Ön köteles haladéktalanul új nyilatkozatot tenni</b> – ezt az
                  I. Blokk jobb felső sarkában{" "}
                  <b>(a „Módosított nyilatkozat” kódkockában)</b> kell X-szel
                  jelölnie.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  Ha a gyermeket nevelő anya jogosultsága a négy vagy több gyermeket nevelő anyák kedvezményére, a három
                  gyermeket nevelő anyák kedvezményére, a két gyermeket nevelő anyák kedvezményére vagy a 30 év alatti anyák
                  kedvezményére úgy áll fenn az év egészében, hogy annak jogcíme megváltozik, a kedvezményt az év egészére
                  az év első napján érvényesíthető kedvezmény – ha ilyenből több is van, az anya döntése szerinti – jogcíme alapján
                  lehet igénybe venni. Ilyen esetben új adóelőleg-nyilatkozat megtételére és a kedvezmény alapjául szolgáló
                  jövedelmek jogcímek közötti megosztására nincs szükség.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  Ha év közben új munkáltatónál helyezkedik el és új nyilatkozatot
                  tesz, az <b>nem számít módosított nyilatkozatnak.</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  A kedvezményekről bővebb tájékoztatást olvashat a NAV honlapján az
                  „Szja adóalap-kedvezmények” című 73. számú információs füzetben.
                </Typography>
                <Box height="25px" />
                <Typography variant="h6">
                  <b>
                    Külföldi magánszemély milyen feltételek mellett érvényesítheti
                    a kedvezményt?
                  </b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  Ön csak akkor érvényesítheti a több gyermeket nevelő anyák kedvezményének valamelyikét, ha azonos vagy
                  hasonló <b>kedvezményt</b> ugyanarra az időszakra <b>másik államban</b> – ahol önálló és nem önálló tevékenységéből,
                  nyugdíjból és más, hasonló, a korábbi foglalkoztatásból származó jövedelme megadóztatható (figyelemmel a
                  kettős adóztatás elkerüléséről szóló nemzetközi egyezmények rendelkezéseire is) - <b>nem vett és nem is vesz
                    igénybe.</b>
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  A külföldi adóügyi illetőségű magánszemély a kedvezményt
                  Magyarországon csak akkor érvényesítheti, ha az adóévben
                  megszerzett összes jövedelmének – ideértve a Magyarországon nem
                  adóztatható jövedelmet is –{" "}
                  <b>75 százaléka Magyarországon adózik.</b> Az adóévben
                  megszerzett összes jövedelembe beleszámít az önálló és nem
                  önálló tevékenységből származó jövedelem – ideértve különösen a
                  vállalkozói jövedelmet és a vállalkozói osztalékalapot vagy az
                  átalányadó alapját – valamint a nyugdíj és más hasonló, a
                  korábbi foglalkoztatásból megszerzett jövedelem, függetlenül
                  attól, hogy mely országban adókötelesek.
                </Typography>
                <Box height="25px" />
                <Typography variant="body1">
                  <b>
                    Ha Ön külföldi adóügyi illetőségű, a „Kiegészítő nyilatkozat a
                    külföldi adóügyi illetőségű magánszemélyek
                    adóalap-kedvezményének érvényesítéséhez” nyilatkozatot is ki
                    kell töltenie és a munkáltató, kifizető részére átadnia a
                    kedvezményének igénybevételéhez. Adóazonosító jelet ebben az
                    esetben is meg kell adnia.
                  </b>
                </Typography>
              </BgBox>
              <Box height="6px" />
              <Box marginLeft="16px">
                <SmallBgBox>
                  (1.) Az Szja törvény 29/D. § (2) bekezdése, a három gyermeket nevelő anyák kedvezményéről szóló 2025. évi XV.
                  törvény 1. § (2) bekezdése és a két gyermeket nevelő anyák kedvezményéről szóló 2025. évi XIV. törvény 1. §
                  (2) bekezdése.
                </SmallBgBox>
              </Box>
            </InlineFlexBoxs>
            <Box height="16px" />
            <BgBox>
              <Typography variant="h5" component={Titles}>
                <b>Az adóelőleg-nyilatkozat kitöltése</b>
              </Typography>
              <Box height="32px" />
              <Typography variant="body1">
                <b style={{ textDecoration: "underline" }}>I. blokk:</b> Ön ebben a blokkban nyilatkozik munkáltatójának arról, hogy érvényesíteni kívánja a több gyermeket
                nevelő anyák kedvezményének valamelyikét.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                <b>Az 1. pontban</b> kell feltüntetni a kedvezmény igénybevételére jogosító gyermekek nevét és adóazonosító jelét. A
                <b> munkáltató, kifizető csak akkor tudja a kedvezményt figyelembe venni, ha Ön</b>
              </Typography>
              <Typography variant="body1" component={ListItems}>
                <li>
                  <b>a két gyermeket nevelő anyák kedvezményére jogosult, akkor 2 gyermek,</b>
                </li>
                <li>
                  <b>a három gyermeket nevelő anyák kedvezményére jogosult, akkor 3 gyermek,</b>
                </li>
                <li>
                  <b>a négy vagy több gyermeket nevelő anyák kedvezményére jogosult, akkor legalább 4 gyermek</b>
                </li>
              </Typography>
              <Box height="10px" />
              <Typography variant="body1">
                <b>adatait feltünteti.</b> Ha a gyermeknek nincs adóazonosító jele, akkor adja meg a gyermek születési helyét, idejét
                és az anyja nevét, még abban az esetben is, ha az megegyezik az Ön nevével.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                Megadhatja az anya a gyermek születési helyét és idejét akkor is, ha a gyermek már felnőtt, de megromlott a
                kapcsolatuk így nem tudja az anya az adóazonosító jelet.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                <b>A 2. pontban</b> nyilatkozik arról, hogy Ön jogosult két gyermeket nevelő anyák kedvezményére vagy a három
                gyermeket nevelő anyák kedvezményére vagy a négy vagy több gyermeket nevelő anyák kedvezményére, és
                igénybe kívánja azt venni.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                <b>A 3. pontban</b> kell jelölni, ha a több gyermeket nevelő anyák kedvezményének valamelyikét folytatólagosan
                kívánja érvényesíteni, vagyis, ha szeretné, hogy munkáltatója, kifizetője a nyilatkozatát folyamatosan figyelembe
                vegye mindaddig, ameddig Ön nem kéri annak mellőzését.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                <b>A 4. pontot</b> akkor töltse ki, ha a továbbiakban{" "}
                <b>nem kívánja</b>  a több gyermeket nevelő anyák kedvezményét
                <b> igénybe venni.</b>  Ekkor a „Módosított nyilatkozat” kódkockát jelölje X-szel, és tüntesse fel azt a hónapot,
                amelyben a kedvezményt már nem kívánja igénybe venni.Ha ezt a pontot kitölti, akkor az 1. és 2. pontot nem
                kell kitöltenie.
              </Typography >
              <Box height="25px" />
              <Typography variant="body1">
                <b style={{ textDecoration: "underline" }}>II. blokk:</b> ezt a
                blokkot az Ön munkáltatójának, kifizetőjének kell kitöltenie.
              </Typography>
            </BgBox >
            <Box height="25px" />
          </Box >
        </Box >
        <OcFooter />
      </Box >
    </ThemeProvider >
  );
};

export default MyTaxThreeChildrenOrMoreTaxCreditInformationPage;
